import { ScreenshotDetails } from '@evinced-private/ui-common';

import { getJiraLabelBySource } from 'src/common/components/details-block/DetailsBlockHelper';
import { ProductType } from 'src/common/interfaces/Tenant';
import { MobileIssueDetails } from 'src/common/types/MobileSingleSessionTypes';
import { Report } from 'src/common/types/ReportModel';

/**
 * Maps MobileIssueDetails to PlatformIssueDetails format
 */
export const mapMobileIssueDetailsToReport = (
	issue: MobileIssueDetails,
	issueId: string,
	isDefaultLabelsEnabled: boolean,
	source: ProductType
): Report => {
	const elements =
		issue.elementInfo?.map((element, index) => ({
			id: `${issueId}-element-${index}`,
			selector: `${element.displayName}: ${element.value}`,
			domSnippet: element.value ?? '',
			componentId: '',
			pageUrl: '',
			boundingBox: issue.screenshotDetails?.boundingBox ?? {
				x: 0,
				y: 0,
				width: 0,
				height: 0
			}
		})) || [];

	// Map WCAG criteria to tags
	const tags =
		issue.WCAGCriteria?.map((criteria, index) => ({
			id: `wcag-${index}`,
			description: criteria.title ?? '',
			link: criteria.link ?? ''
		})) || [];

	const screenshotDetails: ScreenshotDetails | undefined = issue.screenshotDetails
		? ({
				pageScreenshotUrl: issue.screenshotDetails.pageScreenshotUrl,
				boundingBoxes: [issue.screenshotDetails.boundingBox],
				viewportWidth: issue.screenshotDetails.viewportWidth,
				viewportHeight: issue.screenshotDetails.viewportHeight
			} as ScreenshotDetails)
		: undefined;

	return {
		description: issue.description ?? '',
		elements,
		id: issueId,
		knowledgeBaseLink: issue.knowledgeBaseLink ?? '',
		labels: isDefaultLabelsEnabled ? [getJiraLabelBySource(source)] : [],
		note: issue.comment?.text ?? '',
		pageScreenshot: issue.screenshotDetails?.pageScreenshotUrl ?? '',
		pageUrl: '',
		screenshotDetails,
		severity: { id: issue.severity, name: issue.severity, newId: issue.severity },
		signature: '', // will be addressed in Mobile Platform phase 2
		summary: issue.type,
		tags,
		type: { id: issue.type, name: issue.type, newId: issue.type }
	};
};
